export default function SocialProof() {
  return (
    <section className="py-24 md:py-32 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-6 md:px-10">
        <div className="flex flex-col lg:flex-row gap-0">
          <div className="lg:w-[60%] flex flex-col justify-center py-12 lg:py-16 lg:pr-16">
            <p className="text-xs tracking-[0.25em] uppercase text-foreground-500 mb-8 font-label flex items-center gap-2">
              <span className="w-2 h-2 rounded-full bg-accent-500 inline-block"></span>
              Verified by Real Sellers
            </p>

            <blockquote className="font-heading text-4xl md:text-5xl font-semibold text-foreground-950 leading-[1.2] mb-8">
              <span className="text-6xl md:text-7xl text-primary-400 leading-none">&ldquo;</span>
              <br />
              This spreadsheet cut my research time from six hours down to twenty minutes.
            </blockquote>

            <div className="flex items-center gap-3">
              <div className="w-10 h-10 rounded-full bg-secondary-200 flex items-center justify-center">
                <span className="font-heading text-foreground-700 font-bold text-sm">JM</span>
              </div>
              <div>
                <p className="font-semibold text-foreground-900 text-sm">Jordan Miller</p>
                <div className="flex items-center gap-1.5">
                  <i className="ri-star-fill text-xs text-accent-500"></i>
                  <span className="text-xs text-foreground-500">Top-rated Reseller</span>
                </div>
              </div>
            </div>

            <div className="mt-10 flex flex-wrap gap-6">
              <div className="flex items-center gap-2 text-xs text-foreground-600">
                <i className="ri-checkbox-circle-fill text-accent-500 text-sm"></i>
                Shopify stores
              </div>
              <div className="flex items-center gap-2 text-xs text-foreground-600">
                <i className="ri-checkbox-circle-fill text-accent-500 text-sm"></i>
                Amazon FBA
              </div>
              <div className="flex items-center gap-2 text-xs text-foreground-600">
                <i className="ri-checkbox-circle-fill text-accent-500 text-sm"></i>
                TikTok Shop
              </div>
              <div className="flex items-center gap-2 text-xs text-foreground-600">
                <i className="ri-checkbox-circle-fill text-accent-500 text-sm"></i>
                Dropshipping
              </div>
            </div>
          </div>

          <div className="lg:w-[40%] flex items-stretch">
            <div className="w-full rounded-2xl overflow-hidden bg-background-100" style={{ minHeight: "500px" }}>
              <img
                src="https://readdy.ai/api/search-image?query=Confident%20young%20professional%20entrepreneur%20in%20warm%20toned%20minimal%20studio%20portrait%20against%20soft%20cream%20background%20looking%20thoughtful%20black%20and%20white%20editorial%20photography%20clean%20modern%20composition%20natural%20expression%20gentle%20diffused%20lighting&width=600&height=800&seq=social-proof-v2&orientation=portrait"
                alt="Verified reseller portrait"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}